import defineComponent from 'flight';
import uiEffects from 'static/script/utils/ui-effects';
import InitData from 'static/script/app/data/init-data';
import ItemsClickStorage from 'static/script/app/models/items-click-storage';

function AddToCartButtonUI() {
    this._storage = new ItemsClickStorage();

    this.defaultAttrs({
        isFixedPrice: 'view-item-is-fixed-price',
        isShopItem: 'view-item-is-shop-item',
        itemId: null,
        sellerAlias: null,
        fixedPrice: null
    });

    this._addToCart = function () {
        let buyButton = this.$node;

        let payload = {
            price: this.attr.fixedPrice,
            itemid : this.attr.itemId
        };

        payload = this._addSearchIdToPayload(payload);

        if (this._isShopItem()) {
            this._triggerAddToCartEvent();
        } else if (this._isFixedPrice()) {
            this._triggerBuyItNowEvent();
        } else {
            this._logTrackingError();
        }

        buyButton.prop('disabled', true);
        uiEffects.flashBg(buyButton, 'Confirm');

        this.trigger(document, 'ui:cart:on-add-item-to-cart', payload);
    };

    this._addSearchIdToPayload = function (payload) {
        let searchId = this._storage.getSearchId(this.attr.itemId);

        if (searchId) {
            payload.s = searchId;
        }

        return payload;
    };

    this._triggerAddToCartEvent = function () {
        this.trigger(document, 'analytics:track-event', {
            category: 'Cart',
            action: 'Add to cart',
            label: 'Added ' + this.attr.sellerAlias,
            value: this.attr.fixedPrice,
            userTriggered: true
        });
    };

    this._triggerBuyItNowEvent = function () {
        this.trigger(document, 'analytics:track-event', {
            category: 'VIP',
            action: 'BIN button clicked',
            userTriggered: true
        });
    };

    this._logTrackingError = function () {
        let payload = {
            eventName: 'js-onerror',
            message: 'Error in VIP tracking. Missing attributes for buy button',
            url: document.location.href,
            trace: document.location.href + '\n' + this._getInitDataForScribe() + '\n'
        };

        $(document).trigger('data:scribe', payload);
    };

    this._getInitDataForScribe = function () {
        return JSON.stringify(InitData.getForScribe());
    };

    this._addToCartError = function () {
        if (this.$node.prop('disabled') === true) {
            this.$node.removeProp('disabled');
        }
    };

    this._isShopItem = function () {
        return this.$node.data(this.attr.isShopItem) === 'True';
    };

    this._isFixedPrice = function () {
        return this.$node.data(this.attr.isFixedPrice) === 'True';
    };

    this.after('initialize', function () {

        this.on('click', this._addToCart);
        this.on(document, 'data:cart:on-add-item-to-cart-error', this._addToCartError);
    });
}

module.exports = defineComponent.component(AddToCartButtonUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/add-to-cart-button-ui.js